import { ValueFormatterParams } from '@ag-grid-community/core'
import { formatDate } from 'utils/helpers'

export const FILTER_FIELD_PURCHASE_TIMER = 'purchaseTimerFilters'

export const PURCHASE_TIMER_FORM_FIELDS = {
  BARCODE: { key: 'barcode', label: 'Barcode' },
  STORE: { key: 'store', label: 'Store' },
  AVAILABLE_TO_PURCHASE_TIMER: {
    key: 'availableToPurchaseTimer',
    label: 'Available to Purchase Timer',
  },
  PURCHASE_START_TIME: { key: 'purchaseStartTime', label: 'Start Time' },
  PURCHASE_END_TIME: { key: 'purchaseEndTime', label: 'End Time' },
}

export const columns = [
  {
    headerName: 'Barcode',
    field: 'barcode',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Store',
    field: 'store',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Available to Purchase Timer',
    field: 'availableToPurchaseTimer',
    valueFormatter: (params: ValueFormatterParams) =>
      params.value === true ? 'Yes' : params.value === false ? 'No' : '-',
  },
  {
    headerName: 'Start Time',
    field: 'purchaseStartTime',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'End Time',
    field: 'purchaseEndTime',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Updated At',
    field: 'updatedAt',
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatDate(params.value) : '-',
  },
  {
    headerName: 'Created At',
    field: 'createdAt',
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatDate(params.value) : '-',
  },
]
